import type { ReactNode } from 'react';
import FormField from './FormField';
import { scheduleField } from './fieldConfigs';

interface FormWrapperProps {
    children: ReactNode;
    showSchedule?: boolean;
}

export default function FormWrapper({ children, showSchedule = true }: FormWrapperProps) {
    return (
        <div className="space-y-4">
            {children}
            {showSchedule && <FormField config={scheduleField} />}
        </div>
    );
}
